<template>
  <button class="btn btn-esc-red" @click="doRemove">
    <block-spinner :active="isLoading" size="5" color="text-white" class="absolute"></block-spinner>
    <span :class="[{'opacity-0':isLoading}]">Remove</span>
  </button>
</template>

<script>
  import AuthMixins from '@/mixins/AuthMixins';

  export default {
    name: 'JobsRemoveBtn',

    mixins: [AuthMixins],

    props: {
      job_id: {
				type: String
			}
    },

    data() {
      return {
        isLoading: false
      }
    },

    mounted() {

    },

    methods: {
      doRemove() {
				this.isLoading = true;

				let payload = {
					'job_id': this.job_id
				}

				return this.$api.bookmarkJob(payload).then(
					(response) => {
						if (response.data.status == 'success') {
	        		this.updateUser(response.data.enc_user);
							this.isLoading = false;
              this.emitter.emit('toast', {message:'Job removed successfully', type:'success'});
	        	}
					}
				).catch((response) => {
					console.log("Could not toggle job.");
				});
			}
    }
  };
</script>
